import { VehicleStateType } from '../vehicle-state.model';
import { DriverEmployee } from './vehicle-driver.model';
import { Vehicle } from './vehicle.model';

type VehicleDriverFields = Pick<Vehicle, 'operator' | 'lastState'>;

export function getCurrentDriver(
  vehicle: VehicleDriverFields | null | undefined,
): DriverEmployee | null {
  return vehicle?.operator?.current?.employee ?? null;
}

export function getAssignedDriver(
  vehicle: VehicleDriverFields | null | undefined,
): DriverEmployee | null {
  return vehicle?.operator?.assigned?.employee ?? null;
}

export function isVehicleTraveling(
  vehicle: VehicleDriverFields | null | undefined,
): boolean {
  return vehicle?.lastState?.type === VehicleStateType.traveling;
}

export function isVehicleDriving(
  vehicle: VehicleDriverFields | null | undefined,
): boolean {
  const stateType = vehicle?.lastState?.type;
  return (
    stateType === VehicleStateType.traveling ||
    stateType === VehicleStateType.idling
  );
}

/**
 * The backend's `unattendedMovement` is a snapshot taken when the vehicle was
 * fetched, while `lastState` is kept live by the vehicle event stream — so the
 * warning follows the live state and falls back to the flag only when the
 * vehicle has no state loaded.
 */
export function isVehicleMovingUnattended(
  vehicle: VehicleDriverFields | null | undefined,
): boolean {
  const operator = vehicle?.operator;
  if (!operator || operator.current) return false;
  if (vehicle.lastState) return isVehicleTraveling(vehicle);
  return operator.unattendedMovement;
}

export function getVehicleMovingSince(
  vehicle: VehicleDriverFields | null | undefined,
): string | null {
  return isVehicleTraveling(vehicle)
    ? (vehicle?.lastState?.duration?.lower ?? null)
    : null;
}

export function getDriverFullName(
  driver: Pick<DriverEmployee, 'firstName' | 'lastName'> | null | undefined,
): string {
  return `${driver?.firstName ?? ''} ${driver?.lastName ?? ''}`.trim();
}
